<template>
  <v-dialog :value="show" width="500" persistent @input="$emit('update:show', $event)">
    <v-card>
      <v-card-title class="dialog-header" color="primary"> Create a new group </v-card-title>
      <v-divider />
      <v-container>
        <v-card-text>
          <v-form ref="newGroupForm" v-model="formValid" onSubmit="return false;">
            <v-text-field
              class="pa-1"
              outlined
              v-model="groupName"
              :rules="[
                (v) => !!v || 'A group name is required',
                (v) => !!(v && v.length < 255) || 'The group name should be shorter',
              ]"
              label="Group name*"
              required
              @keyup.enter="handleCreate"
            ></v-text-field>
          </v-form>
          <v-data-table
            :value="selectedUsers"
            :headers="groupColumns"
            :items="selectedUsers"
            item-key="userId"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
            no-data-text="No people found"
            :hide-default-footer="selectedUsers.length <= 10"
          >
            <template v-slot:[`item.displayName`]="{ item }">
              <span class="word-break">{{
                item ? item.tableDisplayName || item.displayName : ""
              }}</span>
            </template>
            <template v-slot:[`item.businessEmail`]="{ item }">
              <span class="word-break">
                {{ item.businessEmail || item.businessPhone }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="handleCancel"> Cancel </v-btn>
          <v-btn color="blue darken-1" text @click="handleCreate" :disabled="!formValid">
            Add new group
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreateNewGroupDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedUsers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupName: "",
      formValid: false,
      groupColumns: [
        { text: "Name", value: "displayName" },
        { text: "Email/Phone", value: "businessEmail" },
      ],
    };
  },
  methods: {
    handleCreate() {
      if (this.formValid) {
        this.$emit("create", this.groupName);
      }
    },
    handleCancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    resetForm() {
      this.groupName = "";
      if (this.$refs.newGroupForm) {
        this.$refs.newGroupForm.reset();
      }
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },
};
</script>

<style scoped>
.word-break {
  word-break: break-word;
}
</style>
